/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _module = __webpack_require__(1);
	
	(function () {
	
	  (0, _module.preload)();
	  (0, _module.anchorLink)();
	  (0, _module.pickupSlider)();
	  (0, _module.charaSlider)();
	  (0, _module.toggleMenu)();
	  (0, _module.toggleMovie)("index");
	  (0, _module.sideScroll)();
	  (0, _module.animeScroll)();
	  (0, _module.animeLoad)();
	  (0, _module.mvPin)();
	})();

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var breakPoint = 767;
	var resizeFlag = false;
	var windowWidth = window.innerWidth;
	var windowHeight = window.innerHeight;
	var windowWidthJ = $(window).width();
	
	function videoControl(action, target) {
	  var $playerWindow = $(target)[0].contentWindow;
	  $playerWindow.postMessage('{"event":"command","func":"' + action + '","args":""}', '*');
	}
	
	// ------------------------------------------------------------------------
	// anchorLink
	// ----- BOTH
	// ------------------------------------------------------------------------
	var anchorLink = function anchorLink() {
	  $("a[href^='#']").on("click", function () {
	    var linkSpeed = 800;
	    var linkHref = $(this).attr("href");
	    var linkTarget = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
	    var linkAdjust = 0;
	    var linkPosition = linkTarget.offset().top;
	    $("html, body").animate({ scrollTop: linkPosition - linkAdjust }, linkSpeed, "swing");
	    return false;
	  });
	};
	
	// ------------------------------------------------------------------------
	// pickupSlider
	// ----- BOTH
	// ------------------------------------------------------------------------
	var pickupSlider = function pickupSlider() {
	  $('.pickup-list').slick({
	    slidesToShow: 3,
	    slidesToScroll: 1,
	    arrows: true,
	    dots: true,
	    speed: 500,
	    cssEase: 'ease',
	    // centerMode: true,
	    initialSlide: 0,
	    variableWidth: true,
	    responsive: [{
	      breakpoint: 768,
	      settings: {
	        slidesToShow: 1,
	        swipe: true,
	        centerMode: true,
	        initialSlide: 0
	      }
	    }]
	  });
	};
	
	// ------------------------------------------------------------------------
	// charaSlider
	// ----- BOTH
	// ------------------------------------------------------------------------
	var charaSlider = function charaSlider() {
	  $('.chara-list').slick({
	    slidesToShow: 3,
	    slidesToScroll: 1,
	    arrows: true,
	    dots: true,
	    speed: 500,
	    cssEase: 'ease',
	    centerMode: true,
	    initialSlide: 0,
	    variableWidth: true,
	    responsive: [{
	      breakpoint: 768,
	      settings: {
	        slidesToShow: 1,
	        swipe: true,
	        centerMode: true,
	        initialSlide: 0
	      }
	    }]
	  });
	};
	
	// ------------------------------------------------------------------------
	// toggleMenu
	// ------------------------------------------------------------------------
	var toggleMenu = function toggleMenu() {
	  $(".header-hamburger").on("click", function () {
	    if (!$(".header-hamburger").hasClass("open-movie")) {
	      $(this).toggleClass("open");
	      $(".header-nav").toggleClass("open");
	    }
	  });
	  $("a.header-anchor").on("click", function () {
	    $(".header-hamburger").toggleClass("open");
	    $(".header-nav").toggleClass("open");
	  });
	};
	
	// ------------------------------------------------------------------------
	// toggleMovie
	// ------------------------------------------------------------------------
	var toggleMovie = function toggleMovie(type) {
	  var ua = navigator.userAgent;
	  $(window).on("load", function () {
	    videoControl("playVideo", '#youtube-autoplay');
	  });
	  $(".movie-toggle").on("click", function () {
	    var youtubeId = $(this).data("movie");
	    var embedUrl = "https://www.youtube.com/embed/" + youtubeId + "?autoplay=1&mute=1&enablejsapi=1";
	    $(".sw-Movie").toggleClass("open");
	    $(".header-hamburger").toggleClass("open-movie");
	    $(".header-hamburger button span").text("MOVIE");
	    if (type == "index") {
	      videoControl("pauseVideo", '#youtube-autoplay');
	    }
	
	    $('#youtube-modal').attr("src", embedUrl);
	    $('#youtube-modal').on('load', function () {
	      videoControl("playVideo", '#youtube-modal');
	      if (/android/i.test(ua)) {
	        videoControl("unMute", '#youtube-modal');
	      }
	    });
	  });
	  $(".header-hamburger").on("click", function () {
	    if ($(".header-hamburger").hasClass("open-movie")) {
	      $(".sw-Movie").toggleClass("open");
	      $(".header-hamburger").toggleClass("open-movie");
	      $(".header-hamburger button span").text("MENU");
	      videoControl("pauseVideo", '#youtube-modal');
	      if (type == "index") {
	        videoControl("playVideo", '#youtube-autoplay');
	      }
	    }
	  });
	};
	
	// ------------------------------------------------------------------------
	// sideScroll
	// ------------------------------------------------------------------------
	var sideScroll = function sideScroll() {
	  // $(window).on("load", function () {
	  //   // if (!matchMedia('(max-width: 768px)').matches) {
	  //   //   gsap.to(".sidetext-left", {
	  //   //     backgroundPosition: "left top +=50%",
	  //   //     ease: "none",
	  //   //     scrollTrigger: {
	  //   //       trigger: ".st-Container",
	  //   //       start: "top bottom",
	  //   //       end: "bottom top",
	  //   //       scrub: true
	  //   //     }
	  //   //   });
	  //   //   gsap.to(".sidetext-right", {
	  //   //     backgroundPosition: "left top -=25%",
	  //   //     ease: "none",
	  //   //     scrollTrigger: {
	  //   //       trigger: ".st-Container",
	  //   //       start: "top bottom",
	  //   //       end: "bottom top",
	  //   //       scrub: true
	  //   //     }
	  //   //   });
	  //   // }
	  // });
	};
	
	// ------------------------------------------------------------------------
	// animeScroll
	// ------------------------------------------------------------------------
	var animeScroll = function animeScroll() {
	  $(window).on("load", function () {
	    $(".js-sc").each(function (i, node) {
	      gsap.to(node, {
	        scrollTrigger: {
	          trigger: node,
	          start: 'top bottom-=200',
	          toggleClass: { targets: node, className: "animated" },
	          once: true
	        }
	      });
	    });
	  });
	};
	
	// ------------------------------------------------------------------------
	// animeLoad
	// ------------------------------------------------------------------------
	var animeLoad = function animeLoad() {
	  $(window).on("load", function () {
	    $(".js-ld").toggleClass("animated");
	  });
	};
	
	// ------------------------------------------------------------------------
	// preload
	// ------------------------------------------------------------------------
	var preload = function preload() {
	  $(window).on("load", function () {
	    $("body").removeClass("preload");
	    $("body").css("opacity", "");
	  });
	  setTimeout(function () {
	    $("body").removeClass("preload");$("body").css("opacity", "");
	  }, 5000);
	};
	
	// ------------------------------------------------------------------------
	// mvPin
	// ------------------------------------------------------------------------
	var mvPin = function mvPin() {
	  $(window).on("load", function () {
	    var rate = windowWidth / windowHeight;
	    if (matchMedia('(min-width: 768px)').matches && rate > 1.43) {
	      ScrollTrigger.create({
	        trigger: '.idx-Mainvisual_Inner',
	        pin: '.mv-info',
	        end: 'bottom bottom'
	      });
	    }
	  });
	};
	
	/*-------------------------------------------------------------------*/
	/* download */
	/*-------------------------------------------------------------------*/
	var download = function download() {
	  if (document.querySelector('.js-Download')) {
	    var coloringItem = document.querySelectorAll('.js-Download');
	    var isOS = false;
	    if (navigator.userAgent.match(/iPhone|Android.+Mobile/)) {
	      isOS = true;
	    }
	    coloringItem.forEach(function (item) {
	      // const anchor = item.querySelector('a');
	      // UserAgentからのスマホ判定
	      if (isOS) {
	        item.setAttribute('target', '_blank');
	        item.setAttribute('rel', 'noreferrer noopener');
	        item.removeAttribute('download');
	      }
	    });
	  }
	};
	
	exports.anchorLink = anchorLink;
	exports.pickupSlider = pickupSlider;
	exports.charaSlider = charaSlider;
	exports.toggleMenu = toggleMenu;
	exports.toggleMovie = toggleMovie;
	exports.sideScroll = sideScroll;
	exports.animeScroll = animeScroll;
	exports.animeLoad = animeLoad;
	exports.preload = preload;
	exports.mvPin = mvPin;
	exports.download = download;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// index/app.bundle.js